import { render, staticRenderFns } from "./OnepersonStudentFiles.vue?vue&type=template&id=59170eeb&scoped=true"
import script from "./OnepersonStudentFiles.vue?vue&type=script&lang=js"
export * from "./OnepersonStudentFiles.vue?vue&type=script&lang=js"
import style0 from "./OnepersonStudentFiles.vue?vue&type=style&index=0&id=59170eeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59170eeb",
  null
  
)

export default component.exports